import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTzLpWRVEuaMcq7FLc1MuwezTQoj4BCBY",
  authDomain: "k-dental-37a72.firebaseapp.com",
  projectId: "k-dental-37a72",
  storageBucket: "k-dental-37a72.firebasestorage.app",
  messagingSenderId: "760797290985",
  appId: "1:760797290985:web:bd0e011f00f6a916a7ab78",
  measurementId: "G-GKE1JZYQT9"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Initialize Providers
const googleProvider = new GoogleAuthProvider();
export { auth, googleProvider };
